import React from 'react';
import { FeaturePageLayout } from '../components/FeaturePageLayout';
import { FileText, FileSignature, BookOpen, PieChart, Layout, Send } from 'lucide-react';
/*
  SEO SPECIFICATION:
  Title: AI Document Generator — Proposals, Contracts & Reports in Seconds
  Meta Desc: MISTR generates proposals, contracts, SOPs, and reports automatically — in your brand voice, formatted perfectly, ready to send. Zero manual writing.
  Primary KW: AI document generator for business
*/
export function DocumentGenerator() {
  return <FeaturePageLayout seoTitle="Document Generator — Proposals & Contracts | MindStream.ing" seoDesc="MISTR generates proposals, contracts, SOPs, and reports automatically — in your brand voice, formatted perfectly, ready to send. Zero manual writing." heroEyebrow="DOCUMENT GENERATOR" heroTitle={<>
          Documents That{' '}
          <span className="text-gradient" data-id="element-1529" data-mp="2speq7tsw5d3k">Write Themselves.</span>
        </>} heroDesc="MR generates proposals, contracts, SOPs, and reports automatically — in your brand voice, formatted perfectly, ready to send." heroImage="https://cdn.magicpatterns.com/uploads/dWXrt9xNFh6bNpGwsjysP6/ChatGPT_Image_Mar_20,_2026,_02_15_39_PM.png" howItWorks={{
    title: 'How It Works',
    steps: [{
      title: 'Request',
      desc: 'Tell MR what document you need via voice or text.'
    }, {
      title: 'Generate',
      desc: 'MR pulls context and generates the document instantly.'
    }, {
      title: 'Send',
      desc: 'Review, approve, and send — or let MR auto-send it.'
    }]
  }} problem={{
    subtitle: 'Document creation is tedious. Proposals take hours. Contracts need customization. Reports are manual.',
    cards: [{
      icon: <FileText size={32} data-id="element-1530" data-mp="11kwnctw9mqrd" />,
      title: 'Wasted Hours',
      desc: 'You spend your evenings copying and pasting from old proposals, trying to make the formatting match.'
    }, {
      icon: <FileSignature size={32} data-id="element-1531" data-mp="2z7xq2ozzd26k" />,
      title: 'Costly Errors',
      desc: "You forget to change a client's name in a contract template, looking unprofessional and risking the deal."
    }]
  }} features={{
    cards: [{
      icon: <FileText size={24} data-id="element-1532" data-mp="2lgsrzrc9ghyc" />,
      title: 'Proposal Generation',
      desc: 'Creates highly customized, persuasive proposals based on your sales calls.'
    }, {
      icon: <FileSignature size={24} data-id="element-1533" data-mp="2bid7w8bni8yc" />,
      title: 'Contract Creation',
      desc: 'Drafts accurate agreements with the correct names, dates, and terms.'
    }, {
      icon: <BookOpen size={24} data-id="element-1534" data-mp="9pyiko6s227w" />,
      title: 'SOP Templates',
      desc: 'Turns your voice notes into step-by-step standard operating procedures.'
    }, {
      icon: <PieChart size={24} data-id="element-1535" data-mp="d7wax0ah6o0d" />,
      title: 'Report Automation',
      desc: 'Pulls data from your tools to create beautiful weekly or monthly reports.'
    }, {
      icon: <Layout size={24} data-id="element-1536" data-mp="m19csrqiozyl" />,
      title: 'Brand Formatting',
      desc: 'Ensures every document uses your exact fonts, colors, and logos.'
    }, {
      icon: <Send size={24} data-id="element-1537" data-mp="3qg93g7nuimk4" />,
      title: 'One-Click Send',
      desc: 'Emails the document directly to the client with a personalized message.'
    }]
  }} data-id="element-1528" data-mp="3bmy4pcy4bnxd" />;
}